import { compose } from 'recompose';

import Preload from './preload';

const enhance = compose();
export default enhance(Preload);
